export default function AddUpdateEventPage() {
    return (
        <div>
            <h1>Pat, do you think we should have a separate page for creating an event? </h1>
            <h1>maybe a nice wizard?</h1>
            <h1>probably not needed for this MVP?</h1>
        </div>
    );
}
